import IconComponent, { createIconComponent } from "./IconComponent";
import React from "react";

// Playback
export const PlayIcon = createIconComponent("playback/play");
export const PauseIcon = createIconComponent("playback/pause");
export const ReplayIcon = createIconComponent("playback/replay");

// Debug
export const DebugIcon = createIconComponent("debug/debug");
export const CodeIcon = createIconComponent("debug/code");
export const PlaybackRateIcon = createIconComponent("debug/playback-rate");
export const NextFrameIcon = createIconComponent("debug/next-frame");
export const PrevFrameIcon = createIconComponent("debug/prev-frame");

// Full screen
export const EnterFullscreenIcon = createIconComponent("fullscreen/enter");
export const ExitFullscreenIcon = createIconComponent("fullscreen/exit");

// Volume
export const VolumeLoudIcon = createIconComponent("volume/loud");
export const VolumeMutedIcon = createIconComponent("volume/muted");
export const VolumeQuietIcon = createIconComponent("volume/quiet");

// Share
export const SocialShareIcon = createIconComponent("social/share");
export const FacebookIcon = createIconComponent("social/facebook");
export const TwitterIcon = createIconComponent("social/twitter");

// Loaders
export const LoaderIcon = ({ loaderTrigger }: { loaderTrigger: string }) => {
  return <IconComponent src={"loaders/loader"} className={"c-loader-" + loaderTrigger} stroke={"#fff"} fill={"#fff"} />;
};

// Subtitles
export const SubtitlesIcon = createIconComponent("subtitles/toggle");
export const SubtitlesSelectedIcon = createIconComponent("subtitles/selected");
